// Scene sounds made in the browser (no files to load): a handgun shot outside a store.
// Layers: a sharp crack, the body of the blast, a low thump, and the echo off the buildings.
export function playGunshot(context, volume = 0.6) {
  if (!context) return;
  const now = context.currentTime + 0.01;
  // no compressor: its automatic make-up gain lifted the echo above the shot (measured offline 2026-10-12)
  const out = context.createGain(); out.gain.value = volume;
  out.connect(context.destination);

  const noise = (seconds) => {
    const buf = context.createBuffer(1, Math.ceil(context.sampleRate * seconds), context.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < d.length; i += 1) d[i] = Math.random() * 2 - 1;
    const src = context.createBufferSource(); src.buffer = buf; return src;
  };
  const env = (node, peak, attack, decay, start = now) => {
    const g = context.createGain();
    g.gain.setValueAtTime(0.0001, start);
    g.gain.exponentialRampToValueAtTime(peak, start + attack);
    g.gain.exponentialRampToValueAtTime(0.0001, start + attack + decay);
    node.connect(g); return g;
  };

  // crack: bright, very short
  const crack = noise(0.15);
  const hp = context.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 2500;
  crack.connect(hp); env(hp, 1.6, 0.0005, 0.05).connect(out);
  // body: the blast itself
  const body = noise(0.5);
  const lp = context.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.setValueAtTime(5000, now); lp.frequency.exponentialRampToValueAtTime(400, now + 0.3);
  body.connect(lp); env(lp, 1.4, 0.001, 0.18).connect(out);
  // thump: the pressure wave
  const osc = context.createOscillator(); osc.type = 'sine';
  osc.frequency.setValueAtTime(110, now); osc.frequency.exponentialRampToValueAtTime(38, now + 0.18);
  env(osc, 1.2, 0.001, 0.16).connect(out);
  // echo off the store front and houses: a darker, later copy that fades
  const tail = noise(1.6);
  const tlp = context.createBiquadFilter(); tlp.type = 'lowpass'; tlp.frequency.value = 900;
  tail.connect(tlp);
  const echo = context.createDelay(1.0); echo.delayTime.value = 0.16;
  const fb = context.createGain(); fb.gain.value = 0.25;
  echo.connect(fb).connect(echo);
  env(tlp, 0.12, 0.01, 0.9, now + 0.05).connect(echo);
  echo.connect(out);

  [crack, body, tail].forEach(s => { s.start(now); s.stop(now + 1.8); });
  osc.start(now); osc.stop(now + 0.3);
}

// Scene sounds by name (event.sound in the shared library). A sound that is a file address plays that file.
const SOUNDS = { gunshot: playGunshot };
export function playSound(key, context) {
  const k = String(key || '');
  if (!k) return;
  if (/^(https?:)?\//.test(k)) { try { const a = new Audio(k); a.play().catch(() => {}); } catch { /* no audio */ } return; }
  const f = SOUNDS[k.toLowerCase()];
  if (f) f(context);
}
